import { ActionModel, MessageType } from '@klant/conversational-connector/klant-conversational-connector.model';
import { ChoiceOptionModel, ChoicePromptMessageModel } from '@klant/conversational-connector/models/ChatMessage.model';

import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';

@Component({
    selector: 'message-choice-prompt',
    templateUrl: './message-choice-prompt.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageChoicePromptComponent {
    public readonly sendAction = output<ActionModel>();

    public readonly isLastMessage = input<boolean>(false);
    public readonly occurredAt = input<number>(0);
    public readonly showAvatar = input<boolean>(false);
    public readonly messageChoicePrompt = input<ChoicePromptMessageModel>({} as ChoicePromptMessageModel);

    public readonly isSelected = signal<boolean>(false);

    public readonly showChoiceOptionsSig = computed(() => {
        return this.isLastMessage() && !this.isSelected();
    });

    public onChoiceOptionSelected(choiceOption: ChoiceOptionModel): void {
        const action: ActionModel = {
            messageType: MessageType.PICK_CHOICE_ACTION,
            originMessage: this.messageChoicePrompt().id,
            choiceOptionId: choiceOption.id,
            text: choiceOption.text
        };

        this.sendAction.emit(action);
        this.isSelected.set(true);
    }
}
